<template>
  <MinimalLayout :loading="step === 'loading'">
    <SuccessStatus
      v-if="step === 'done'"
      :message="t('link.stopNotificationSuccess')"
      :subtitle="t('link.closePage')"
    />

    <ErrorStatus v-else>{{ t("link.errorOccurred") }}</ErrorStatus>
  </MinimalLayout>
</template>

<script lang="ts" setup>
import ErrorStatus from "@/components/ErrorStatus.vue";
import MinimalLayout from "@/components/MinimalLayout.vue";
import SuccessStatus from "@/components/SuccessStatus.vue";
import { useI18n } from "@/composables/useI18n";
import { call } from "@/firebase";
import { captureException } from "@sentry/vue";
import { ref } from "vue";
import { useRoute } from "vue-router";

const { t } = useI18n();
const route = useRoute();

const step = ref<"loading" | "done" | "error">("loading");

void (async () => {
  try {
    // ?projectId in links sent before the rename
    const accountId = route.query.accountId ?? route.query.projectId;
    const contactId = route.query.contactId;
    if (
      !accountId ||
      !contactId ||
      typeof accountId !== "string" ||
      typeof contactId !== "string"
    ) {
      step.value = "error";
      return;
    }

    console.log(
      `Execute Link StopNotification for account ${accountId} and contactId ${contactId}`,
    );
    await call("stopOperatorNotifications")({ accountId, contactId });

    step.value = "done";
  } catch (cause) {
    const error = new Error("Error in Link StopNotification init function", { cause });
    console.error(error);
    captureException(error);
    step.value = "error";
  }
})();
</script>
